$(document).ready(function () {
  const params = new URLSearchParams(window.location.search);
  if(params.has('country'))
    $('#wtbButton').click();
});